import React, { useContext } from 'react';

import './terminos.scss';

import Container from 'components/container/container';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { AppContext } from 'helpers/Context';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

export default function Terminos() {
	const { t, i18n } = useTranslation();
	const { branch, setBranchStatus } = useContext(AppContext);
	const { identify, setIdentifyStatus } = useContext(AppContext);

	let params: any = useParams();

	useEffect(() => {
		if (!identify) {
			window.analytics.identify();
			setIdentifyStatus(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		setBranchStatus(params.branch);
		i18n.changeLanguage(params.branch);
	}, [branch, i18n, setBranchStatus, params.branch]);

	return (
		<div className="App">
			<Helmet>
				<title>Términos y Condiciones - Connect Assistance</title>
				<meta
					name="description"
					content="Connect Assistance es la compañía #1 en Asistencia en Carretera y en el Hogar en Puerto Rico, Panamá, Costa Rica y Colombia"
				/>
				<meta
					property="og:description"
					content="Connect Assistance es la compañía #1 en Asistencia en Carretera y en el Hogar en Puerto Rico, Panamá, Costa Rica y Colombia"
				/>
			</Helmet>
			<div className="App-header">
				<Container>
					<div className="terminos-container">
						<h2 className="text-center ">Términos y Condiciones</h2>
						<h4>Ultima actualización: {t('terminosfecha')}</h4>

						<div
							className="margin-top-30"
							dangerouslySetInnerHTML={{
								__html: t('terminos'),
							}}
						></div>
					</div>
				</Container>
			</div>
		</div>
	);
}
